module.exports = __webpack_public_path__ + "static/media/201EC106.dcc51832.jpg";